import React from 'react';
import { motion } from 'framer-motion';
import { pageWrapperStyle } from '../../styles/pageStyles.js';
import './PolicyPage.css';

const PrivacyPolicy = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, backgroundColor: 'var(--alt-background)' }}
    >
      <section className="policy-page section">
        <div className="container">
          <div className="policy-content">
            <h1>Privacy Policy</h1>
            <p className="last-updated">Last updated: June 11, 2025</p>

            <p>This website, www.digitalfig.com (the "Site"), is owned and operated by Digital Fig Ltd, a company registered in England and Wales (Company No. 15889833) ("we", "us", or "our").</p>

            <h2>1. What information we collect</h2>
            <p><strong>Information you provide:</strong> name, email address, phone, job title, business details and message content when you contact us.</p>
            <p><strong>Automatically collected data:</strong> IP address, browser type and version, pages visited, time and date of visits, and referral data.</p>

            <h2>2. How we use your data</h2>
            <ul>
              <li>Provide and improve services.</li>
              <li>Respond to enquiries.</li>
              <li>Send updates, newsletters, or offers (with opt‑in consent).</li>
              <li>Monitor and analyse site/trend usage.</li>
              <li>Comply with legal obligations.</li>
            </ul>

            <h2>3. Sharing your data</h2>
            <ul>
              <li>With trusted service providers (e.g., email hosts, analytics).</li>
              <li>To comply with legal obligations.</li>
              <li>During business transfers (mergers, acquisitions).</li>
            </ul>
            <p>We do not sell or rent personal data without consent.</p>

            <h2>4. Cookies & tracking technologies</h2>
            <p>Our Site uses cookies:</p>
            <ul>
              <li><strong>Necessary</strong> (essential for site function)</li>
              <li><strong>Analytics</strong> (e.g., Google Analytics)</li>
              <li><strong>Marketing</strong> (e.g., targeted ads)</li>
            </ul>
            <p>You can manage or disable cookies via your browser settings; some features may then be limited.</p>

            <h2>5. Data retention and transfers</h2>
            <p>We retain personal data only as long as necessary.</p>
            <p>Data may be stored and processed in the UK or EU. We ensure appropriate safeguards are in place.</p>

            <h2>6. Your rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access, correct, and delete your personal data.</li>
              <li>Restrict or object to processing.</li>
              <li>Withdraw consent at any time.</li>
              <li>Lodge a complaint with the UK Information Commissioner's Office (ICO).</li>
            </ul>

            <h2>7. External links</h2>
            <p>We are not responsible for the privacy practices of external links leading away from our Site.</p>

            <h2>8. Changes to this policy</h2>
            <p>We may update this policy occasionally. We'll inform you and update the "Last updated" date. Please review periodically.</p>

            <h2>9. Contact us</h2>
            <p>For questions or data access requests, please email: <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a>.</p>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default PrivacyPolicy;